import { Link } from 'react-router-dom';
import { categories } from '@/mocks/navigation';

interface CategoryNavProps {
  activeCategory: string;
  onCategoryChange?: (slug: string) => void;
  useLink?: boolean;
}

export default function CategoryNav({ activeCategory, onCategoryChange, useLink = false }: CategoryNavProps) {
  return (
    <div className="flex items-center gap-1.5 overflow-x-auto pb-1 scrollbar-hide flex-wrap">
      {categories.map((cat) => {
        const isActive = activeCategory === cat.slug;

        if (useLink) {
          return (
            <Link
              key={cat.id}
              to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                isActive
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
              }`}
            >
              <i className={`${cat.icon} text-base`}></i>
              {cat.name}
            </Link>
          );
        }

        return (
          <button
            key={cat.id}
            onClick={() => onCategoryChange?.(cat.slug)}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
              isActive
                ? 'bg-primary-500 text-white'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
            }`}
          >
            <i className={`${cat.icon} text-base`}></i>
            {cat.name}
          </button>
        );
      })}
    </div>
  );
}